// Primitivos de tabla compartidos por las tabs globales del CRM en Operations
// (Tickets — Fase 4, Llamadas — Fase 5). Th/Td dan la cabecera/celda con el
// mismo estilo, y FilterCell envuelve un control de filtro con su etiqueta.
//
// Extraídos de Tickets/index.tsx (había un TODO para unificarlos con Coupons en
// cuanto Llamadas los necesitara — ese momento es ahora). Coupons se deja como
// está para no ensanchar el diff.

import React from "react";

// `width` fija un ancho orientativo de columna (la tabla usa table-layout auto,
// así que actúa como preferencia, no como tope rígido) para repartir el espacio
// entre muchas columnas en lugar de dejar que las de texto largo colapsen al
// resto. Se aplica en el <th> para que gobierne toda la columna.
export function Th({
  children,
  width,
}: {
  children: React.ReactNode;
  width?: number | string;
}) {
  return (
    <th
      style={{
        padding: "0.6rem 0.7rem",
        textAlign: "left",
        fontWeight: 600,
        color: "#1f2933",
        fontSize: ".72rem",
        textTransform: "uppercase",
        letterSpacing: ".3px",
        whiteSpace: "nowrap",
        width,
      }}
    >
      {children}
    </th>
  );
}

// `truncate` recorta el contenido a una línea con ellipsis dentro de `maxWidth`
// (por defecto 220px). Úsalo en celdas de texto libre largo (asunto, email,
// nombre) para que no ensanchen la fila ni empujen a las demás columnas fuera de
// la vista. Acompáñalo de un `title` en el hijo para el tooltip completo.
export function Td({
  children,
  truncate,
  maxWidth = 220,
}: {
  children: React.ReactNode;
  truncate?: boolean;
  maxWidth?: number | string;
}) {
  return (
    <td
      style={{
        padding: "0.55rem 0.7rem",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        ...(truncate
          ? {
              maxWidth,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }
          : {}),
      }}
    >
      {children}
    </td>
  );
}

export function FilterCell({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div style={{ minWidth: 150 }}>
      <div
        style={{
          fontSize: ".68rem",
          color: "#73879C",
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: ".3px",
          marginBottom: "0.25rem",
        }}
      >
        {label}
      </div>
      {children}
    </div>
  );
}

// Shared filter/text input style (was duplicated verbatim in Tickets and Calls).
export const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "0.4rem 0.55rem",
  borderRadius: "0.4rem",
  border: "1px solid #dee2e6",
  fontSize: ".82rem",
  boxSizing: "border-box",
};

// Red banner shown when a list fetch fails (with an inline Reintentar button).
export const errorBox: React.CSSProperties = {
  background: "#fde2e2",
  color: "#b32424",
  padding: "0.5rem 0.7rem",
  borderRadius: "0.4rem",
  marginBottom: "1rem",
  fontSize: ".85rem",
};

// Inline "Reintentar" button rendered inside errorBox.
export const retryInline: React.CSSProperties = {
  marginLeft: "0.5rem",
  background: "white",
  color: "#0069d9",
  border: "1px solid #dee2e6",
  borderRadius: "0.35rem",
  padding: "0.2rem 0.6rem",
  fontSize: ".78rem",
  fontWeight: 600,
  cursor: "pointer",
};

// Toggle Lista↔Tablero (pill link) shared by the Tickets list and the board so
// both views render the switch identically.
export const viewToggleLink: React.CSSProperties = {
  color: "#0069d9",
  fontSize: ".82rem",
  fontWeight: 600,
  textDecoration: "none",
  border: "1px solid #bfdbfe",
  borderRadius: "0.4rem",
  padding: "0.3rem 0.7rem",
};

// Prev/next (and "Cargar más") pager button; dims + disables the cursor when
// there is nothing more to page to.
export function pagerBtn(disabled: boolean): React.CSSProperties {
  return {
    padding: "0.35rem 0.8rem",
    borderRadius: "0.4rem",
    border: "1px solid #dee2e6",
    background: "white",
    color: "#0069d9",
    fontSize: ".8rem",
    fontWeight: 600,
    cursor: disabled ? "default" : "pointer",
    opacity: disabled ? 0.5 : 1,
  };
}
